<div>
  <div
    class="bg-[#1f2937] border border-gray-700 rounded-lg p-6 w-full flex flex-col items-stretch justify-start"
  >
    <div class="w-100 flex justify-start">
      <h3 class="text-lg text-white mb-6">{{ label() }}</h3>
    </div>
    <div class="flex justify-center">
      <ng-content />
    </div>
  </div>
</div>
